<template>
  <ais-rating-menu
    v-slot="{ items, refine }"
    :attribute="TYPESENSE_ATTRIBUTE.AVG_RATING"
   :max="MAX_STARS">

      <RatingMenuInner
        :items="items"
        :refine="refine"
      />


  </ais-rating-menu>
</template>

<script lang="ts">

import { AisRatingMenu } from 'vue-instantsearch/vue3/es';
import { TYPESENSE_ATTRIBUTE, MAX_STARS } from '~~/constants/typesense';

export default defineComponent({
  name: 'RatingMenu',
  components: {

    AisRatingMenu,
  },
  setup() {

    return { TYPESENSE_ATTRIBUTE, MAX_STARS };

  },
});

</script>
